import { styled as t, TextField as l } from "@mui/material";
import { DEFAULT_ANIMATE_DURATION as r } from "../../../constants/layout.js";
import { jsx as e } from "react/jsx-runtime";
const i = `
  :-webkit-autofill {
    animation-name: onAutoFillStart;
    transition: background-color 500000s ease-in-out 0s;
  }

  :not(:-webkit-autofill) {
    animation-name: onAutoFillCancel;
    transition: background-color 0.1s linear 0s;
  }

  @keyframes onAutoFillStart {
    from {
      background-color: #0b0b0c;
    }
    to {
      background-color: #0b0b0c;
    }
  }

  @keyframes onAutoFillCancel {
    from {
      background-color: #0b0b0c;
    }
    to {
      background-color: #0b0b0c;
    }
  }
`, n = t(l)`
  .MuiOutlinedInput-input {
    background-color: #0b0b0c;

    :-webkit-autofill {
      box-shadow: 0 0 0 50px #0b0b0c inset; // chrome auto fill color
      -webkit-text-fill-color: white; // chrome auto fill color
    }

    ${i}
  }

  .MuiFormHelperText-root {
    margin-left: 0px;
    color: red;
  }

  .MuiOutlinedInput-notchedOutline {
    transition: border-color ${r}ms;
    border-color: transparent;
  }
`, b = (o) => /* @__PURE__ */ e(n, {
  className: o.className,
  size: "small",
  fullWidth: !0,
  variant: "outlined",
  ...o
});
export {
  b as default
};
//# sourceMappingURL=Textfield.js.map
